import { Injectable } from '@angular/core';
import { ServerService } from './ServerService';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SuporteAvaliacaoService extends ServerService {

  constructor(private httpCliente: HttpClient) {
    super(httpCliente);
  }

  obtenhaAvaliacao(token: string) {
    return this.obtenha(`/suporte-avaliacoes/publica/${token}`, {});
  }

  responda(token: string, avaliacao: any) {
    return this.facaPost(`/suporte-avaliacoes/publica/${token}/responder`, avaliacao);
  }
}
